<template>
  <div class="check-detail">
    <div id="printArea" :style="{ width: printWidth + 'mm' }">
      <h2 class="title">新能源营运车辆日常安全检查单</h2>

      <div class="info-table">
        <table>
          <tr>
            <td width="15%">车牌号</td>
            <td width="20%">{{ mainBill.vehicleNo }}</td>
            <td width="24%">车型品牌</td>
            <td width="20%">{{ mainBill.brand }}</td>
            <td width="10%">车辆颜色</td>
            <td width="15%">{{ mainBill.color }}</td>
          </tr>
          <tr>
            <td>驾驶司机</td>
            <td>{{ mainBill.driverName }}</td>
            <td>司机是否确认</td>
            <td>是</td>
            <td>检查日期</td>
            <td>{{ (mainBill.arriveDate || mainBill.billDate) | dateFormat("yyyy-MM-dd") }}</td>
          </tr>
          <tr>
            <td>检查项目</td>
            <td colspan="5" class="content-cell">检查结果</td>
          </tr>
          <tr v-for="(item, index) in displayItems" :key="`${item.itemName || 'item'}-${index}`">
            <td>{{ item.itemName || "未命名项目" }}</td>
            <td colspan="5" class="content-cell">
              <div v-if="isTireItem(item)" class="tire-row">
                <div class="inline-photo-list">
                  <div v-for="(img, pIdx) in item.photoes" :key="`${index}-${pIdx}`" class="inline-photo-item">
                    <img :src="img" alt="轮胎照片" />
                  </div>
                </div>
                <div class="result-text result-text-right">{{ formatItemContent(item) }}</div>
              </div>
              <div v-else class="result-text">{{ formatItemContent(item) }}</div>
            </td>
          </tr>
          <tr>
            <td>底盘电池照片</td>
            <td colspan="5" class="content-cell photo-cell">
              <div class="photo-area">
                <div class="photo-list">
                  <div v-for="(img, index) in checkImgs" :key="index" class="photo-item">
                    <img :src="img" alt="车辆照片" />
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>检查单位</td>
            <td>{{ mainBill.providerName }}</td>
            <td>当前里程数</td>
            <td>{{ totalMilesText }}</td>
            <td>检查人员</td>
            <td>{{ mainBill.staffName }}</td>
          </tr>
          <tr>
            <td>检查人员签名</td>
            <td colspan="5" class="content-cell">
              <img :src="mainBill.staffSign" width="60px" height="auto" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckDetailNew",
  props: {
    printWidth: {
      type: Number,
      default: 210
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    data: {
      handler(newVal) {
        const { mainBill, detail, items } = newVal;
        this.detail = detail;
        this.mainBill = mainBill;
        this.items = items || [];
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tirePhotoPositions() {
      return [
        { key: "lf", label: "左前" },
        { key: "rf", label: "右前" },
        { key: "lb", label: "左后" },
        { key: "rb", label: "右后" }
      ];
    },
    displayItems() {
      return this.items || [];
    },
    tirePhotoMap() {
      const map = { lf: [], rf: [], lb: [], rb: [] };
      const items = this.displayItems || [];
      items.forEach((item) => {
        const n = item.itemName;
        const key = n.includes("左前") ? "lf" : n.includes("右前") ? "rf" : n.includes("左后") ? "lb" : n.includes("右后") ? "rb" : "";
        if (key) map[key].push(...(item.photoes || []));
      });

      return {
        lf: [...new Set(map.lf)],
        rf: [...new Set(map.rf)],
        lb: [...new Set(map.lb)],
        rb: [...new Set(map.rb)]
      };
    },
    hasTirePhotos() {
      return this.tireImgs.length > 0;
    },
    tireImgs() {
      const { lf, rf, lb, rb } = this.tirePhotoMap;
      return [...new Set([...(lf || []), ...(rf || []), ...(lb || []), ...(rb || [])])];
    },
    checkImgs() {
      const tireSet = new Set(this.tireImgs);
      const imgs = [];
      const items = this.displayItems || [];
      items.forEach((item) => {
        const n = item.itemName;
        const isTireItem = n.includes("左前") || n.includes("右前") || n.includes("左后") || n.includes("右后");
        const isTarget = n.includes("底盘") || n.includes("电池") || n.includes("车身");
        if (!isTireItem && isTarget) imgs.push(...(item.photoes || []).filter((img) => !tireSet.has(img)));
      });

      return [...new Set(imgs)];
    },

    totalMilesText() {
      const milesItem = (this.displayItems || []).find((item) => item.itemName.includes("里程")) || {};
      return milesItem.desc;
    }
  },
  data() {
    return {
      detail: {},
      mainBill: {},
      items: []
    };
  },
  methods: {
    isTireItem(item) {
      const n = (item && item.itemName) || "";
      return n.includes("左前") || n.includes("右前") || n.includes("左后") || n.includes("右后");
    },
    formatItemContent(item) {
      const raw = String(item.desc || "");
      const desc = raw.trim().startsWith("检查结果") ? raw.trim() : `检查结果：${raw}`;
      let text = desc;
      if (item.remark) text += `\n备注：${item.remark}`;
      return text;
    }
  }
};
</script>

<style lang="less" scoped>
.check-detail {
  padding: 20px;

  #printArea {
    margin: 0 auto;
    padding: 20px;
    background: #fff;

    .title {
      text-align: center;
      margin-bottom: 20px;
      font-size: 20px;
    }

    .info-table {
      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;

        td {
          border: 1px solid #000;
          padding: 8px;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
        }

        .content-cell {
          min-height: 60px;
          vertical-align: top;
        }

        .result-text {
          white-space: pre-wrap;
        }

        .tire-row {
          display: flex;
          gap: 10px;
          align-items: center;
          justify-content: space-between;
        }

        .result-text-right {
          flex: 0 0 160px;
          text-align: left;
          font-weight: 600;
          padding-top: 2px;
        }

        .inline-photo-list {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          flex: 1 1 auto;
          justify-content: center;
          align-items: center;
        }

        .inline-photo-item {
          img {
            width: 110px;
            height: 70px;
            object-fit: cover;
            border: 1px solid #dcdfe6;
          }
        }

        .photo-cell {
          min-height: 120px;

          .photo-area {
            min-height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px dashed #ccc;
            margin-bottom: 10px;

            .photo-list {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;

              .photo-item {
                img {
                  width: 130px;
                  object-fit: cover;
                  margin: 0 6px;
                }
              }
            }
          }

          .tire-photo-area {
            align-items: stretch;

            .tire-position-grid {
              width: 100%;
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 12px;

              .tire-position-item {
                border: 1px solid #dcdfe6;
                padding: 8px;

                .position-title {
                  margin-bottom: 8px;
                  font-weight: 600;
                }

                .photo-list {
                  min-height: 100px;
                  justify-content: center;
                }
              }
            }
          }
        }
      }
    }
  }

  @media print {
    padding: 0;
    background: #fff;
  }
}
</style>
